import { css } from 'styled-components';

/** Clash Display Semibold as its own family so Safari/Opera cannot substitute Light/Regular. */
export const fontDisplay = css`
  font-family: 'ClashTOL-Semibold', sans-serif !important;
  font-stretch: normal;
  font-weight: 600 !important;
  font-synthesis: none;
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
`;

export const fontUi = css`
  font-family: var(--tol-font-ui);
  font-stretch: normal;
`;

export const fontCondensed = css`
  font-family: var(--tol-font-condensed);
  font-stretch: condensed;
`;

/** Clash Display’s em-box sits high on Windows/Opera; trim + flex keeps chips even. */
export const opticalCenter = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  text-box: trim-both cap alphabetic;
  text-box-trim: trim-both;
  text-box-edge: cap alphabetic;
`;

/** SVG <text> at a circle’s center. dy approximates cap-height; skip dominant-baseline (Safari). */
export const svgCenteredText = css`
  text-anchor: middle;
`;

export const pill = css`
  ${fontUi};
  ${opticalCenter};
  box-sizing: border-box;
  font-weight: 600;
  text-align: center;
  border-radius: 6px;
`;

export const sectionTitle = css`
  ${fontDisplay};
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: -0.02em;
  text-transform: none;
  color: ${({ theme }) => theme.text};
  margin: 0;
`;

export const viewMoreLink = css`
  ${fontUi};
  ${opticalCenter};
  gap: 4px;
  color: ${({ theme }) =>
    theme.isDark ? theme.headerAccent : theme.success};
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  &:hover {
    color: ${({ theme }) =>
      theme.isDark ? theme.headerAccent : theme.success};
    opacity: 0.85;
  }
`;
